<template>
  <div class="password-modal">
    <LmDialog v-model="open" :styles="{ minWidth: '900px' }" title="Change Password">
      <template #toolbar-actions>
        <q-btn color="tertiary" size="sm" @click.native="changePassword">
          Save
        </q-btn>
      </template>
      <template #content>
        <q-card-section>
          <div class="fields row">
            <q-input
              v-if="!loggedUser.is_system_user"
              v-model.trim="payload.old_password"
              stack-label
              label="Old Password"
              class="col"
              type="password"
              autocomplete="new-password"
              outlined
            />

            <q-input
              v-model.trim="payload.new_password"
              stack-label
              label="New Password"
              class="col"
              type="password"
              autocomplete="new-password"
              outlined
            />

            <q-input
              v-model.trim="payload.new_password_confirmation"
              stack-label
              label="Confirm New Password"
              class="col"
              type="password"
              autocomplete="new-password"
              outlined
            />
          </div>
        </q-card-section>
      </template>
    </LmDialog>
  </div>
</template>

<script>
import * as apiTo from '@/modular-api'
// Components
import LmDialog from '@/reusable/base-components/LmDialog/LmDialog'

export default {
  components: {
    LmDialog
  },

  data: () => ({
    open: false,
    userId: null,
    loading: false,
    payload: {
      old_password: '',
      new_password: '',
      new_password_confirmation: ''
    }
  }),

  computed: {
    loggedUser() {
      return this.$store.state.user
    }
  },

  methods: {
    openModal(userId) {
      this.userId = userId
      this.open = true
    },

    changePassword() {
      this.loading = true

      const payload = {
        new_password: this.payload.new_password,
        new_password_confirmation: this.payload.new_password_confirmation,
        ...(this.loggedUser.is_system_user ? {} : { old_password: this.payload.old_password }) // don't add `old_password` if is a system user
      }

      apiTo
        .CHANGE_USER_PASSWORD(this.userId, payload)
        .then(() => Object.assign(this.$data, this.$options.data.apply(this)))
        .finally(() => (this.loading = false))
    }
  }
}
</script>

<style lang="scss" scoped>
.fields {
  gap: var(--r-space-sm);
}
</style>
